module.exports = __webpack_public_path__ + "static/instagram-logo-7a71b6414b5ea2db9d5516fa4a5a57f3.png";